module.exports = __webpack_public_path__ + "img/icon-number-seven.2c85d632.svg";